<template>
  <div>

    <b-table-simple class="export-table" borderless outlined style="border-bottom: 0">
      <b-thead>
        <b-tr class="title-row">
          <b-th colspan="4">{{ lodash.startCase($t('delivery_orders.singular')) }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td style="width: 125px">No</b-td>
          <b-td class="text-gray" style="width: 200px">: {{ orderId }}</b-td>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.resumes.to')) }}</b-td>
          <b-td class="text-gray">: {{ factoryName }}</b-td>
        </b-tr>
        <b-tr>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.resumes.load_date')) }}</b-td>
          <b-td class="text-gray" style="width: 150px">: {{ dateFormatter(loadDate) }}</b-td>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.resumes.address')) }}</b-td>
          <b-td class="text-gray">: {{ address  }}</b-td>
        </b-tr>
        <b-tr>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.resumes.unload_date')) }}</b-td>
          <b-td class="text-gray" style="width: 150px">: {{ dateFormatter(unloadDate) }}</b-td>
          <b-td></b-td>
          <b-td></b-td>
        </b-tr>
        <b-tr>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.resumes.armada')) }}</b-td>
          <b-td class="text-gray" style="width: 150px">: {{ vehicleFormatter(vehicle) }}</b-td>
          <b-td></b-td>
          <b-td></b-td>
        </b-tr>
        <b-tr>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('trips.driver')) }}</b-td>
          <b-td class="text-gray" style="width: 150px">: {{ driverFormatter(driver) }}</b-td>
          <b-td></b-td>
          <b-td></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'trip-export',
  props: {
    value: {type: Object, default: function () { return {} }},
  },
  computed: {
    address() {
      let {
        customer: {
          region_full_name,
          address : { street }
        } = {}
      } = this.value?.trip || {}
      let result = street

      if (region_full_name) result = `${region_full_name}, ${result}`

      return result
    },
    driver() {
      return this.value?.trip?.driver
    },
    vehicle() {
      return this.value?.trip?.vehicle
    },
    loadDate() {
      return this.value?.trip?.tripped_at
    },
    unloadDate() {
      return this.value?.ordered_at
    },
    factoryName() {
      return this.value?.trip?.customer?.name || '-'
    },
    trippedAt() {
      if (!this.value?.tripped_at) return '-'
      return this.$moment.utc(this.value.tripped_at).local().format('DD MMMM YYYY')
    },
    orderId() {
      return this.value?.trip?.delivery_order?.order_id || '-'
    },
    partnerNames() {
      let customerNames = this.purchaseOrders?.map(({ customer: { name }}) => name)
      if (!customerNames.length) return '-'
      return this.lodash.uniq(customerNames).join(', ')
    },
    productServiceNames() {
      let names = this.purchaseOrders?.map(({product: {name}}) => name)
      if (!names.length) return '-'
      return this.lodash.uniq(names).join(', ')
    },
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    dateFormatter(value) {
      if (!value) return '-'
      let day = this.$moment.utc(value).local().format('dddd')
      let date = this.$moment.utc(value).local().format('DD MMMM YYYY')
      return `${day}, ${date}`
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    driverFormatter(value) {
      if (this.lodash.isEmpty(value)) return '-'
      let {name, phone_number} = value
      return `${name} (${phone_number})`
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    },
    vehicleFormatter(value) {
      if (this.lodash.isEmpty(value)) return '-'
      let {type, license_plate} = value
      if (type === 'heavy') type = this.lodash.upperFirst(this.$t('vehicles.truck'))
      else if (type === 'medium') type = this.lodash.upperFirst(this.$t('vehicles.crank_truck'))
      else if (type === 'ligh') type = this.lodash.upperFirst(this.$t('vehicles.pickup'))

      return `${type} (${license_plate})`
    }
  }
}
</script>

<style lang="scss" scoped>

</style>